import { SendHorizonal, Square } from "lucide-react"
import React, { useState } from "react"
import { cn } from "@/utils/styles"

interface StreamingChatInputProps {
  onSendMessage: (message: string) => void
  disabled?: boolean
  isStreaming?: boolean
  onStopStreaming?: () => void
  placeholder?: string
}

export const StreamingChatInput: React.FC<StreamingChatInputProps> = ({
  onSendMessage,
  disabled = false,
  isStreaming = false,
  onStopStreaming,
  placeholder = "Type your message...",
}) => {
  const [message, setMessage] = useState("")

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (message.trim() && !disabled && !isStreaming) {
      onSendMessage(message.trim())
      setMessage("")
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  const handleStopStreaming = () => {
    onStopStreaming?.()
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center gap-3 border-t border-gray-200 bg-white p-4"
    >
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className={cn(
          "max-h-32 min-h-8 flex-1 resize-none rounded-2xl border border-neutral-300 px-4 py-3 font-sans text-base outline-none transition-colors focus:ring-2 focus:ring-brown-500 focus-visible:ring-offset-2",
          {
            "cursor-not-allowed bg-gray-100 text-gray-500": isStreaming,
            "bg-white": !isStreaming,
          },
        )}
        maxLength={2000}
      />

      {isStreaming ? (
        <button
          onClick={handleStopStreaming}
          className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-red-500 text-white transition-all duration-200`}
          type="button"
        >
          <Square size={18} />
        </button>
      ) : (
        <button
          type="submit"
          disabled={!message.trim() || disabled || isStreaming}
          className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full text-white transition-all duration-200 ${
            !message.trim() || disabled || isStreaming
              ? "cursor-not-allowed bg-gray-300"
              : "bg-brown-500"
          } `}
        >
          <SendHorizonal size={18} />
        </button>
      )}
    </form>
  )
}
